var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 152,
    viewBox: "0 0 171 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.806 84.1862C132.208 56.2723 160.52 66.3198 170.75 74.8328C169.47 26.953 137.266 7.85518 121.324 4.29124C52.4578 -15.3935 16.0336 37.2889 13.7482 68.1826C11.0972 164.351 101.718 151.924 103.747 150.994C71.4745 113.947 98.2903 89.4174 100.806 84.1862Z",
    fill: "#F08B1F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_946_6091)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3909 47.0753L22.122 47.4875L32.613 53.4023L43.104 47.4875L43.8351 47.0753L44.5662 47.4875L55.0572 53.4023L65.5482 47.4875L66.2793 47.0753L67.0104 47.4875L77.5014 53.4023L87.9924 47.4875L89.4546 50.1162L78.2325 56.4431L77.5014 56.8553L76.7703 56.4431L66.2793 50.5284L55.7883 56.4431L55.0572 56.8553L54.3261 56.4431L43.8351 50.5284L33.3441 56.4431L32.613 56.8553L31.8819 56.4431L21.3909 50.5284L10.8999 56.4431L10.1688 56.8553L9.43768 56.4431L-1.78442 50.1162L-0.322248 47.4875L10.1688 53.4023L20.6598 47.4875L21.3909 47.0753ZM21.3909 65.4535L22.122 65.8657L32.613 71.7805L43.104 65.8657L43.8351 65.4535L44.5662 65.8657L55.0572 71.7805L65.5482 65.8657L66.2793 65.4535L67.0104 65.8657L77.5014 71.7805L87.9924 65.8657L89.4546 68.4944L78.2325 74.8213L77.5014 75.2335L76.7703 74.8213L66.2793 68.9066L55.7883 74.8213L55.0572 75.2335L54.3261 74.8213L43.8351 68.9066L33.3441 74.8213L32.613 75.2335L31.8819 74.8213L21.3909 68.9066L10.8999 74.8213L10.1688 75.2335L9.43768 74.8213L-1.78442 68.4944L-0.322248 65.8657L10.1688 71.7805L20.6598 65.8657L21.3909 65.4535ZM22.122 84.2439L21.3909 83.8317L20.6598 84.2439L10.1688 90.1587L-0.322248 84.2439L-1.78442 86.8726L9.43768 93.1995L10.1688 93.6117L10.8999 93.1995L21.3909 87.2848L31.8819 93.1995L32.613 93.6117L33.3441 93.1995L43.8351 87.2848L54.3261 93.1995L55.0572 93.6117L55.7883 93.1995L66.2793 87.2848L76.7703 93.1995L77.5014 93.6117L78.2325 93.1995L89.4546 86.8726L87.9924 84.2439L77.5014 90.1587L67.0104 84.2439L66.2793 83.8317L65.5482 84.2439L55.0572 90.1587L44.5662 84.2439L43.8351 83.8317L43.104 84.2439L32.613 90.1587L22.122 84.2439Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_946_6091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.652 109.78C28.3669 102.4 22.6826 96.1156 19.9976 97.1356C16.3617 98.5686 21.2752 109.869 24.1236 114.787C28.8779 123.09 34.6208 128.696 37.0168 127.432C40.4977 125.459 34.8093 113.497 32.652 109.78Z",
    fill: "#F07CF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1078 92.3939C57.387 84.175 51.6609 78.6199 49.2984 80.0024C46.9359 81.3848 48.8335 89.1527 53.5417 97.3716C58.2499 105.59 63.9928 111.133 66.3511 109.763C68.7094 108.393 66.8161 100.613 62.1078 92.3939Z",
    fill: "#6158DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.497 29.8336C110.053 26.9127 107.594 23.8949 105.299 22.4366C105.056 22.2764 104.817 22.1289 104.578 21.9856C99.3799 25.6104 89.8671 31.4731 78.6997 33.256C77.8619 33.3993 76.7854 33.1886 76.1319 33.7829C74.0752 35.6289 73.6605 42.086 68.5711 42.2125C67.8674 44.0122 67.2307 45.7445 66.5437 47.2197C67.3815 46.0479 73.4553 47.1606 75.0009 47.5105C76.5466 47.8603 83.0477 49.6179 82.7712 51.0425C83.9189 48.5515 83.4707 46.0311 82.7209 43.401C91.8484 41.6519 104.469 35.1653 110.497 29.8336Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3678 109.763C64.9185 110.606 62.2041 108.849 59.2468 105.477C59.2958 106.641 59.6235 107.776 60.2019 108.785C62.2125 112.579 62.1162 121.919 64.353 121.261C64.9729 121.067 65.706 117.889 66.3636 114.248C66.6989 112.487 67.1466 110.75 67.7041 109.047C67.415 109.186 66.6485 109.578 66.3678 109.763Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6545 29.2562C75.9472 30.114 76.3789 30.9173 76.9321 31.6333C78.3354 31.4268 79.8936 30.9969 80.1868 30.3478C80.2381 30.2392 80.2801 30.1264 80.3125 30.0106C79.9481 31.1824 77.8244 30.3984 75.6545 29.2562Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5355 20.6369C74.7122 17.6529 65.5093 19.9963 59.268 24.5399C53.0267 29.0834 54.786 33.3657 62.9248 31.41C62.4431 31.5533 57.2448 33.1254 53.8435 37.0578C48.8504 42.8363 53.19 45.0659 58.7863 43.8942C65.4884 42.516 71.2145 36.9946 73.1623 33.1718C74.0553 30.9198 74.6619 28.5633 74.9677 26.1583C72.6387 24.249 74.0587 22.5167 75.3321 23.8318C76.0191 24.5399 76.7857 24.2027 75.9395 21.893C76.794 21.3619 77.8245 21.1891 77.5355 20.6369Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8358 113.969C98.5418 110.159 98.5853 106.329 98.9657 102.526C95.9373 103.386 92.7249 103.335 89.7252 102.379C89.7922 105.047 88.9628 106.395 89.6456 108.048C90.0582 108.975 90.6441 109.813 91.3714 110.518C94.3706 113.569 96.9383 122.559 98.9112 121.274C99.4432 120.92 99.2338 117.662 98.8358 113.969Z",
    fill: "#6158DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8267 46.7223C68.6837 47.4685 68.4589 48.1965 68.1565 48.8929C65.5552 47.5905 66.1626 46.7391 68.8267 46.7223Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8009 51.0383C82.7381 51.346 82.3066 51.5357 81.5903 51.6284C81.8626 51.1311 82.1014 50.6801 82.3066 50.2333C82.6752 50.5452 82.8512 50.8192 82.8009 51.0383Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9722 75.6696L88.2967 80.4998C88.2296 78.62 88.1668 76.7739 88.1333 74.9615L89.9722 75.6696Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6913 109.042C67.1402 110.747 66.6926 112.484 66.3509 114.243C65.7058 117.889 64.9644 121.071 64.3403 121.261C62.1118 121.935 62.1956 112.579 60.1933 108.785C59.616 107.775 59.2884 106.641 59.2383 105.477",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.913 48.6358C122.628 48.1714 122.255 47.768 121.815 47.4487C121.375 47.1294 120.877 46.9004 120.349 46.7747C119.821 46.6491 119.274 46.6293 118.739 46.7165C118.203 46.8037 117.69 46.9961 117.229 47.2829C117.015 47.4136 116.814 47.5646 116.63 47.7338C116.452 47.1238 116.137 46.5632 115.709 46.0956C115.281 45.628 114.752 45.2659 114.162 45.0376C113.572 44.8093 112.939 44.7208 112.309 44.7791C111.68 44.8373 111.073 45.0408 110.535 45.3735C110.069 45.6622 109.664 46.0405 109.343 46.4867C109.023 46.9329 108.793 47.4384 108.667 47.9741C108.004 47.4719 107.206 47.1829 106.378 47.1447C105.549 47.1066 104.728 47.3211 104.023 47.7603C103.317 48.1994 102.76 48.8427 102.424 49.6059C102.088 50.369 101.99 51.2164 102.14 52.0372C101.602 51.8966 101.042 51.8653 100.492 51.9449C99.9417 52.0245 99.4128 52.2134 98.9359 52.5008C98.3979 52.8331 97.943 53.2853 97.6062 53.8225C97.2694 54.3597 97.0597 54.9676 96.9933 55.5992C96.9269 56.2309 97.0056 56.8694 97.2233 57.4656C97.441 58.0619 97.7919 58.5998 98.249 59.0379C97.7449 59.2375 97.2848 59.5351 96.8951 59.9136C96.5054 60.2922 96.1937 60.7444 95.9778 61.2442C95.7619 61.7441 95.646 62.2819 95.6368 62.8269C95.6276 63.3718 95.7253 63.9133 95.9242 64.4202C96.2763 65.323 96.9362 66.0701 97.7858 66.5281C98.6354 66.986 99.6192 67.1248 100.561 66.9196L122.833 53.1794C123.394 52.8295 124.073 50.524 122.913 48.6358Z",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.015 55.0086C106.54 55.5076 106.879 56.1734 106.974 56.894C107.069 57.6147 106.914 58.3462 106.537 58.9657C106.159 59.5853 105.58 60.0551 104.899 60.2962C104.217 60.5373 103.474 60.535 102.794 60.2897",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.942 52.1804C115.856 52.8307 115.571 53.438 115.128 53.919C114.684 54.4001 114.104 54.7312 113.466 54.8669C112.828 55.0027 112.164 54.9365 111.565 54.6773C110.966 54.4182 110.461 53.9788 110.12 53.4196C109.976 53.1779 109.863 52.9187 109.785 52.6483",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.625 47.7339C116.197 48.1422 115.841 48.6211 115.574 49.15",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7026 58.764C99.2067 58.7895 98.7165 58.8816 98.2449 59.0379",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.663 47.9741C108.558 48.4973 108.541 49.0343 108.612 49.5631",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.72 52.7831C103.242 52.4417 102.707 52.1891 102.14 52.0371",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.593 57.9126C127.407 55.9527 124.965 55.6029 124.538 55.9232L102.249 69.6888C101.613 70.0723 100.737 72.4031 101.948 74.3756C102.261 74.8921 102.684 75.3328 103.185 75.6668C103.687 76.0007 104.256 76.2197 104.851 76.3081C105.446 76.3966 106.053 76.3524 106.629 76.1787C107.205 76.005 107.736 75.706 108.185 75.3029C108.44 76.1872 108.983 76.9602 109.725 77.499C110.467 78.0378 111.367 78.3115 112.282 78.2767C113.197 78.2418 114.073 77.9003 114.773 77.3065C115.473 76.7127 115.955 75.9007 116.144 74.9994C116.803 75.5058 117.599 75.8001 118.427 75.844C119.256 75.8878 120.078 75.6792 120.787 75.2452C121.495 74.8113 122.057 74.1723 122.399 73.4118C122.741 72.6514 122.847 71.8048 122.703 70.9827C123.588 71.2093 124.522 71.1336 125.358 70.7675C126.195 70.4015 126.887 69.7659 127.326 68.9607C127.764 68.1556 127.924 67.2266 127.78 66.3199C127.637 65.4132 127.197 64.5804 126.532 63.9524C127.039 63.7597 127.504 63.4681 127.899 63.0943C128.294 62.7206 128.612 62.272 128.835 61.7743C129.058 61.2767 129.18 60.7397 129.196 60.1942C129.212 59.6487 129.121 59.1054 128.928 58.5954C128.835 58.359 128.723 58.1306 128.593 57.9126V57.9126Z",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.268 70.1945C115.104 69.6361 114.791 69.1339 114.362 68.7429C113.933 68.3518 113.406 68.087 112.838 67.9773C112.269 67.8676 111.682 67.9174 111.14 68.1211C110.598 68.3248 110.122 68.6747 109.764 69.1324C109.416 69.5866 109.191 70.1239 109.111 70.6918",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.271 62.5869C121.66 62.3793 121 62.365 120.38 62.5459C119.76 62.7269 119.21 63.0945 118.803 63.5992C118.397 64.1039 118.154 64.7217 118.107 65.3695C118.059 66.0173 118.21 66.6642 118.539 67.2231C118.684 67.4658 118.862 67.6871 119.067 67.8806",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 63.9482C125.97 64.1594 125.376 64.2679 124.776 64.2685",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.068 74.1354C108.83 74.5645 108.532 74.9576 108.185 75.3029",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.703 70.9785C122.191 70.8299 121.706 70.5994 121.266 70.2957",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.194 73.2755C116.269 73.8476 116.253 74.428 116.148 74.9952",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.249 69.6803L99.874 71.126",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.561 66.9196L98.2153 68.3484",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1956 78.2701L62.8574 93.7426",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6849 74.7844L61.2493 90.9524",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.179 30.1244C115.853 29.5959 121.558 30.7286 126.608 33.3861C131.657 36.0436 135.836 40.1127 138.642 45.1038C147.116 59.7587 142.68 78.6831 128.735 87.3699C120.014 92.8027 117.593 89.9325 100.67 94.7879",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5354 109.641C74.2847 105.574 81.1963 102.02 88.3173 99.1039",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4235 66.3169C62.0451 70.6497 56.1598 74.873 49.2817 79.9771",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5245 41.1208C87.1811 46.1798 83.4292 50.953 79.3069 55.3921",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.578 22.0025C107.276 23.5282 110.024 26.6388 110.514 29.8336C104.469 35.1653 91.8485 41.635 82.7378 43.4179C83.4876 46.0479 83.9358 48.5684 82.788 51.0593C83.0645 49.6558 76.6263 47.8898 75.0178 47.5273C73.4093 47.1648 67.3857 46.0774 66.5605 47.2365C67.2475 45.7613 67.8842 44.0248 68.5879 42.2293C73.6774 42.086 74.0837 35.6205 76.1488 33.7997C76.798 33.2223 77.8243 33.4162 78.7165 33.2729C89.8797 31.4436 99.3967 25.6314 104.595 22.0025H104.578Z",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4734 50.0941C72.0375 50.0229 76.5321 51.225 80.4588 53.5671",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.241 30.1834C79.7174 31.098 77.7068 30.3351 75.6333 29.2561C75.9269 30.1136 76.3585 30.9167 76.9109 31.6333",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1259 33.315C77.0159 33.041 77.3133 32.4973 76.9321 31.6291C79.9313 31.1823 80.4507 30.6259 80.3251 29.1002C80.145 26.9001 78.8632 22.1163 77.5353 20.6158",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7377 43.4179C81.812 43.5949 80.9197 43.7213 80.0903 43.8014",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9434 21.8886C76.7812 24.2026 76.0272 24.5397 75.336 23.8274C74.0584 22.5124 72.6384 24.2489 74.9674 26.154C74.6646 28.5605 74.0593 30.9186 73.1662 33.1717C71.2184 36.9903 65.4755 42.5159 58.7902 43.8941C53.1897 45.049 48.8501 42.8362 53.8474 37.0577C57.2445 33.1211 62.447 31.549 62.9246 31.4099C54.8066 33.3655 53.0054 29.1002 59.2719 24.5355C65.5384 19.9709 74.7161 17.6485 77.5394 20.6368C77.8242 21.1848 76.7602 21.3786 75.9434 21.8886Z",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6086 42.2293C69.4508 39.9353 70.5364 37.7393 71.8466 35.6795C72.3644 34.8987 72.8076 34.0703 73.1703 33.2054",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3323 55.3584C80.4388 53.7188 81.4351 52.0065 82.3147 50.2332",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.995 21.2185C116.403 20.6411 118.385 21.7327 118.221 22.6642C118.184 22.8504 118.108 23.0266 117.998 23.1813C117.888 23.336 117.747 23.4657 117.584 23.562",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.769 19.7391C116.307 19.1279 118.829 20.4134 117.744 21.7622",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.241 28.6787C111.744 26.9553 113.672 25.6601 115.829 24.9233",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.898 22.9465C116.244 22.4661 117.785 23.3975 117.693 24.3121C117.58 25.4375 115.348 27.1403 113.467 26.0486",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.917 18.8877C111.951 18.854 112.922 17.4926 112.495 17.0585C112.126 16.6876 106.828 21.071 105.345 22.4661",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.966 19.579C119.176 17.539 120.307 15.0818 119.511 15.5328C116.853 16.8749 114.123 18.0694 111.335 19.1111C109.179 19.9383 107.153 21.0739 105.32 22.483",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9652 102.526C98.589 106.329 98.5455 110.159 98.8354 113.969C99.2542 117.662 99.4427 120.92 98.8982 121.274C96.9378 122.559 94.3617 113.577 91.3583 110.518C90.6297 109.814 90.0436 108.976 89.6325 108.048C88.9456 106.391 89.7791 105.043 89.7121 102.366",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1075 92.3939C66.8199 100.613 68.73 108.389 66.3508 109.759C63.9715 111.129 58.2496 105.586 53.5414 97.3673C48.8331 89.1485 46.923 81.3848 49.2981 80.0023C51.6731 78.6199 57.3909 84.1708 62.1075 92.3939Z",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.892 122.888C36.7024 115.415 29.5144 102.986 23.7087 98.4969C20.7011 96.1535 18.5439 96.5665 18.791 100.499C19.2601 107.959 27.5163 122.374 33.6781 126.589C37.1003 128.919 38.5706 127.128 37.892 122.888Z",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1926 127.326L41.9259 124.57C42.383 124.211 42.6939 123.696 42.8004 123.122C42.9068 122.549 42.8014 121.956 42.504 121.455C44.389 124.313 48.0877 121.362 46.6007 118.888C47.9788 121.248 52.3058 119.731 50.5256 116.14C50.9289 116.666 51.504 117.032 52.1492 117.173C52.7945 117.314 53.4686 117.222 54.0526 116.911C55.9794 115.676 55.2631 113.27 54.0526 109.35C51.8154 102.623 48.2682 96.4113 43.6182 91.0789C42.5011 89.7395 41.222 88.5459 39.8106 87.5258C37.5779 86.1307 35.0646 87.176 35.9275 90.9693C35.2196 89.7765 34.3861 88.9968 32.9954 89.3761C32.3849 89.5447 31.8658 89.9499 31.5517 90.5029C31.2376 91.0559 31.1543 91.7117 31.3198 92.3265C31.3778 92.538 31.4637 92.7407 31.5754 92.9292C31.5754 92.9292 29.925 90.8218 28.0526 92.3181C27.5863 92.6827 27.2721 93.2092 27.1714 93.7947C27.0707 94.3801 27.1907 94.9823 27.508 95.4834C27.2055 94.946 26.7034 94.5515 26.112 94.3863C25.5207 94.2212 24.8883 94.2989 24.3538 94.6025H24.3329L19.876 97.1819",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8265 46.7223C68.6835 47.4685 68.4587 48.1965 68.1562 48.8929C65.555 47.5905 66.1624 46.7391 68.8265 46.7223Z",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7879 51.0593C82.7084 51.3501 82.2979 51.5398 81.6067 51.6325",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8267 46.7223C68.5648 48.5468 67.6449 50.2106 66.2422 51.3965C59.959 56.4037 59.8752 63.4171 64.4536 68.6772",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.591 97.3842L12.5244 101.418",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.849 127.503L30.5029 131.229",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4409 133.172L22.7327 135.933",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23667 103.487L4.43628 106.235",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1362 114.804L8.67944 124.005",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60066 125.948L0.90918 128.692",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.082 61.2845C65.5428 64.2053 67.1764 66.8859 69.3714 67.5772C76.2369 69.7351 88.1206 74.9784 88.1206 74.9784C88.2672 83.2436 89.0128 92.3433 88.2169 101.852C92.0212 103.462 96.2912 103.559 100.163 102.122C100.834 93.1484 101.265 84.546 101.106 76.5968C101.071 74.6198 100.615 72.6733 99.7709 70.8879C98.9263 69.1024 97.7119 67.5195 96.2092 66.2453C90.0069 61.0876 83.093 56.8638 75.6839 53.7062",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1162 74.9783L89.9509 75.6695L88.2754 80.4997",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5476 95.5087C92.4252 96.8492 96.6012 97.0553 100.59 96.103",
    stroke: "#141414",
    strokeWidth: 0.679209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8267 51.6283C68.8267 51.6283 62.7514 61.2346 68.588 65.1578C72.2532 66.8606 91.9365 74.1354 91.9365 74.1354C91.9365 74.1354 90.5248 77.739 90.5248 80.4997C90.5248 83.1846 89.951 93.7427 89.951 93.7427C89.951 93.7427 93.1638 95.8964 98.9737 94.7879V78.2701C98.9737 78.2701 98.781 70.4896 93.0549 66.9196C87.3288 63.3497 74.4733 55.8895 74.4733 55.8895C74.4733 55.8895 73.0323 54.486 73.979 52.8043L68.8267 51.6283Z",
    fill: "#6158DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_946_6091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.3254,
    height: 79.5349,
    fill: "white",
    transform: "translate(0.75 25.9225)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_946_6091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142.353,
    height: 120.775,
    fill: "white",
    transform: "translate(0.75 15.3178)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.ba9bb3b6d6b45d5bad820c4031b3cde5.svg";
export { ForwardRef as ReactComponent };